import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import type { UpdateVehicleBookingTimesPayload } from "../../../utils/axios-requests";

export type { UpdateVehicleBookingTimesPayload } from "../../../utils/axios-requests";

/**
 * Updates a fleet vehicle booking's start/end times (PUT /booking-schedule/update-vehicle-booking-times).
 * Use mutateAsyncSafe when calling from UI so errors are handled in the hook and the promise never rejects.
 */
export function useRemoteUpdateFleetBookingTimes() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useRemoteMutation<void, RemoteApiError, UpdateVehicleBookingTimesPayload>({
    key: ["fleet", "update-booking-times"],
    url: "/booking-schedule/update-vehicle-booking-times",
    method: "put",
    snackbarTextOnSuccess: t("Booking updated"),
    onSuccess: () => {
      queryClient.invalidateQueries(["fleet", "vehicles"]);
      queryClient.invalidateQueries(["fleet", "booking-events"]);
    }
  });
}
